<div *ngIf="spinner==true">
  <ngx-spinner  size="medium"  type="timer" >
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div>
<div class="container-fluid">
  <div class="card shadow">
     <div class="card-header">
          <div class="d-flex justify-content-between">
            <h4 class="font-weight-bold text-dark py"> ZONE-WISE BEARER REPORT</h4>
            <div style="width:220px">
            <label>Zone / மண்டலம்</label>
            <select class="form-control" (change)="DistrictChange($event)">
                <!-- <option value="" disabled selected hidden>Select District</option> -->
                <option *ngFor="let option of district_list" (value)="option">
                    {{option}}</option>
            </select>
          </div>
          </div>
      </div>
      <!-- DISTRICT ADMIN DATATABLE         -->
      <div class="wrapper" >
        <div class="card-body">
            <div class="table-responsive" *ngIf="tableshow">
                <!-- TABLE -->
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>District</th>
                            <!-- <th>District Admin</th> -->
                            <th>Name</th>
                            <th>Mobile Number</th>
                            <th>Photo</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers[0]">
                            <td style="min-width: 20px;">
                                {{customer.district}}
                            </td>
                            <!-- <td style="min-width: 20px;">
                              {{customer.admin_names}}
                          </td> -->
                            <td style="min-width: 20px;">
                                {{customer.name}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.contact_no}}
                            </td>
                            <td style="min-width: 20px;">
                              <img [src]="customer.image_encode"  style="height: 190px; width:160px; border: 1px solid #555; " >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
      </div>
    </div>
